import { useContext, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { MessageContext } from "../context/MessageContext";

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { showMessage } = useContext(MessageContext);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const API_URL = process.env.REACT_APP_API_URL;
    console.log(API_URL);

    const res = await fetch(
      `${API_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();
    console.log(!res.ok || data.success === false);

    if (!res.ok || data.success === false) {
      showMessage(data.message, "danger");
    }


    if (data && data.user) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      showMessage(data.message, "success");
      navigate("/");
    } else {
      setError("Invalid email or password");
    }
  }
  return (
    <>
      <div style={{ marginBottom: '50px' }}></div>
      <div className="page-title">
        <nav className="breadcrumbs">
          <div className="container">
            <ol>
              <li><NavLink to="/">Home</NavLink></li>
              <li className="current">Login</li>
            </ol>
          </div>
        </nav>
      </div>
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-5 col-md-7">
              <div className="card shadow-sm">
                <div className="card-body p-4">

                  <h4 className="text-center mb-4">
                    <i className="bi bi-person-circle me-2"></i>
                    Account Login
                  </h4>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Email address</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="remember"
                        />
                        <label className="form-check-label" htmlFor="remember">
                          Remember me
                        </label>
                      </div>

                      <NavLink to="/forgot-password" className="small">
                        Forgot password?
                      </NavLink>
                    </div>

                    <div className="d-grid">
                      <button type="submit" className="btn btn-primary">
                        Login
                      </button>
                    </div>
                  </form>

                  <div className="text-center mt-4">
                    <span className="small">
                      Don’t have an account?
                    </span>{" "}
                    <NavLink to="/register" className="fw-semibold">
                      Register
                    </NavLink>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
